'use strict';

import raven from 'raven';
import angular from 'angular';
import Config from 'config';
import Promise from 'bluebird';
import SimpleMessages from '../../../controllers/simple-messages';

import AddCashReturnController from './add-cashreturn.controller';
import AddCashReturnTpl from './add-cashreturn.html';
import CreatePendingSpendingController
    from './create-pendingspending.controller';
import CreatePendingSpendingTpl from './create-pendingspending.html';
import { sortByNameProp } from 'app/helpers/sorting';

class VoucherCollectionController {
    /* @ngInject */
    constructor(
        VouchersService,
        WorkersService,
        PendingSpendingsService,
        $scope,
        $mdDialog,
        $mdToast,
        $state,
        $location,
        $window,
        LoopBackAuth
    ) {
        let voucher = $scope.$parent.$resolve.voucher;
        this.model = voucher;
        this.user = $scope.$parent.$resolve.user;

        Object.assign(this, {
            VouchersService,
            WorkersService,
            PendingSpendingsService,
            $scope,
            $mdDialog,
            $mdToast,
            $state,
            $location,
            $window,
            LoopBackAuth
        });
        Object.assign(this, SimpleMessages);

        if (this.model.id) {
            this.neverEditable = true;
            this.pendingSpendings = this.model.pendingSpendings;
        } else {
            this.model.cashAmount = 0;
            this.model.depositAmount = 0;
            this.model.pendingAmount = 0;
            this.pendingSpendings = [];
        }

        this.worker = this.model.worker;
        this.cashReturns = $scope.$parent.$resolve.cashReturns;
        this.registries = $scope.$parent.$resolve.registries;
        this.cashboxes = $scope.$parent.$resolve.cashboxes.sort(sortByNameProp);
    }

    $onInit() {
    }

    addCashReturn(ev) {
        this.$mdDialog.show({
            controller: AddCashReturnController,
            template: AddCashReturnTpl,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: this.$scope.customFullscreen,
            locals: {
                cashboxes: this.cashboxes,
                defaultCashbox: this.cashboxes.find(
                    c => c.employeeId == this.user.employeeId
                )
            }
        }).then(data => {
            return this.VouchersService.addCashReturn(
                Object.assign(data, {id: this.model.id})
            ).then(cashboxTx => {
                this.simpleSuccess();
                this.model.remainingAmount -= cashboxTx.amount;
                this.cashReturns.push(cashboxTx);
            }, err => {
                this.simpleError();
                raven.captureException(err);
            });;
        }, err => {
            // closed dialog
        });
    }

    addPendingSpending(ev) {
        this.$mdDialog.show({
            controller: CreatePendingSpendingController,
            template: CreatePendingSpendingTpl,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: this.$scope.customFullscreen,
            locals: {
                registries: this.registries
            }
        }).then(data => {
            let ps = this.PendingSpendingsService.create(
                Object.assign(data, {srcVoucherId: this.model.id})
            );
            this.PendingSpendingsService.save(ps).then(pendingSpending => {
                pendingSpending.registry = data.registry;
                this.simpleSuccess();
                this.model.remainingAmount -= pendingSpending.amount;
                this.model.generatedPendingSpendings.push(pendingSpending);
            }, err => {
                this.simpleError();
                raven.captureException(err);
            });
        }, err => {
            // closed dialog
        });
    }

    voidCashReturn($event, cashReturnTx) {
        console.debug(cashReturnTx);
        const confirm = this.$mdDialog.confirm()
            .title('Está seguro?')
            .textContent('Desea realmente anular la devolución de efectivo?')
            .ok('Sí, anular')
            .cancel('Cancelar');

        this.$mdDialog.show(confirm).then(() => {
            return this.VouchersService.voidCashReturn({
                voucherId: this.model.id,
                cashboxTxId: cashReturnTx.id
            });
        }).then((voidTx) => {
            this.cashReturns.push(voidTx);
            cashReturnTx.metadata.voided = true;
            this.model.remainingAmount += voidTx.amount;
            this.simpleSuccess();
        });
    }

    isVoidable(cashReturnTx) {
        return !cashReturnTx.metadata.voided &&
            cashReturnTx.metadata.type == 'voucherCashReturn';
    }
}

export default VoucherCollectionController;
